import { Outlet } from 'react-router-dom';

import { MainLayout } from './MainLayout';

export const AuthenticatedLayout = () => (
  <MainLayout>
    <Outlet />
  </MainLayout>
);
